import notification from '@/mixins/notification'

export default {
  mixins: [notification],
  methods: {
    shippingRateApiUserMessage(error, fallback = 'Erro ao salvar o frete.') {
      let raw = this.apiErrorsMessage(error, fallback)
      let translations = {
        'Pickup location has already been taken':
          'Já existe frete cadastrado para este local de retirada com esta região.',
      }
      return raw
        .split('. ')
        .map((part) => translations[part.trim()] || part)
        .join('. ')
    },
  },
}
